export const selects = ({ isMobile }) => ({
  display: "flex",
  flexDirection: isMobile ? "column" : "row",
  mx: "30px",
  py: isMobile ? "30px" : "40px",
});

export const select = ({ isMobile }) => ({
  mb: isMobile ? "20px" : "0",
  mx: isMobile ? "0" : "10px",
  width: isMobile ? "100%" : "50%",
});

export const recommendation = () => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textTransform: "uppercase",
  mb: "20px",
});
